import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';
import Link from '../link/link';
import SaveButton from '../buttons/saveButton/saveButton';
import PrintButton from '../buttons/printButton/printButton';
import SearchButtonContainer from '../buttons/searchButton/searchButtonContainer';
import ArticleInfoButtonContainer from '../buttons/articleInfoButton/articleInfoButtonContainer';
import SearchInputContainer from '../search/containers/searchInputContainer';
import PageCounterContainer from '../pageCounter/pageCounterContainer';
import { trackAdobeEvent } from '../../utils/trackers/adobe';
import PrintProgress from '../printProgress/printProgress';
import { HELP_LINK } from '../../constants';
import viewerFeaturePropTypes from '../viewerFeaturePropTypes';
import ViewOnlyDisclaimer from '../viewOnlyDisclaimer/viewOnlyDisclaimer';

const faqLink = process.env.IS_PLUGIN
  ? HELP_LINK.BROWSER_EXTENSION
  : HELP_LINK.WEB;

function faqClick() {
  trackAdobeEvent(
    'linkOut',
    {
      link: {
        location: faqLink,
        name: 'FAQ',
      },
    },
  );
}

export default function ButtonsToolbar(props) {
  const {
    downloadUrl,
    isSearching,
    isLoadingDocumentForPrint,
    viewerFeature,
    isSmallestBreakpoint,
  } = props;
  const saveInfoButton = (
    <>
      {viewerFeature.save && <SaveButton downloadUrl={downloadUrl} />}
      <ArticleInfoButtonContainer />
    </>
  );

  const getCurrentView = (isSearchView, isPrintView) => {
    if (isSearchView) {
      return (
        <>
          <SearchInputContainer />
          {isSmallestBreakpoint && saveInfoButton}
        </>
      );
    }
    if (isPrintView) {
      return <PrintProgress />;
    }
    return (
      <Fragment>
        <PageCounterContainer />
        <SearchButtonContainer />
        {viewerFeature.print && <PrintButton />}
        <Link
          href={faqLink}
          className="toolbar-icon u-margin-m-right"
          target="_blank"
          rel="noopener noreferrer"
          title="Elsevier Enhanced Reader FAQs"
          onClick={faqClick}
          id="faq-link"
        >
          <Icon.Help />
        </Link>
        {saveInfoButton}
        {viewerFeature.viewOnlyDisclaimer && <ViewOnlyDisclaimer />}
      </Fragment>
    );
  };
  return getCurrentView(isSearching, isLoadingDocumentForPrint);
}

ButtonsToolbar.propTypes = {
  clearPrintProgress: PropTypes.func,
  downloadUrl: PropTypes.string,
  isLoadingDocumentForPrint: PropTypes.bool,
  isSearching: PropTypes.bool,
  isSmallestBreakpoint: PropTypes.bool,
  viewerFeature: PropTypes.shape(viewerFeaturePropTypes),
};

ButtonsToolbar.defaultProps = {
  clearPrintProgress: () => {},
  downloadUrl: '',
  isLoadingDocumentForPrint: false,
  isSearching: false,
  isSmallestBreakpoint: true,
  viewerFeature: {
    print: true,
    save: true,
    viewOnlyDisclaimer: false,
  },
};
